import React from "react";
import Grid from "@mui/material/Grid2";
import { Box, LinearProgress, Paper, styled, Typography } from "@mui/material";
import { palette, theme as colorTheme } from "../../../Convoze.theme";



const primary = colorTheme("palette", "primary").value;
const primaryBg = colorTheme("palette", "primaryBg").value;
const positive = colorTheme("palette", "positive").value;
const negative = colorTheme("palette", "negative").value;
const neutral = colorTheme("palette", "neutral").value;




const ScoreItem = ({ label, score, maxScore = 10 }) => {
  const percentage = (score / maxScore) * 100;

  const getColor = (score) => {
    if (score >= 75) return positive 
    if (score >= 55) return neutral
    if (score >= 0) return negative
    return "#E5E7EB"; 
  };

  return (
    <Box sx={{ mb: 1.5 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 0.5,
        }}
      >
        <Typography
          variant="body1"
          color="rgb(75 85 99 / var(--tw-text-opacity, 1))"
          fontSize={"0.875rem"}
        >
          {label}
        </Typography>
        <Typography variant="body1" fontWeight={"bold"} fontSize={"0.875rem"}>
          {score?`${score}%`:0}
        </Typography>
      </Box>
      <StyledLinearProgress
        variant="determinate"
        value={score}
        color={getColor(score)}
      />
    </Box>
  );
};
const StyledLinearProgress = styled(LinearProgress)(
  ({ theme, value, color }) => ({
    height: 8,
    borderRadius: 4,
    backgroundColor: "#f0f0f0",
    "& .MuiLinearProgress-bar": {
      borderRadius: 4,
      backgroundColor: color,
    },
  })
);
function Parameters({ parametersData }) {
  const parameterData = [
    { label: "Greeting", score: parametersData?.Greeting },
    {
      label: "Product Knowledge",
      score: parametersData?.ProductKnowledge,
    },
    { label: "Tone & Manner", score: parametersData?.ToneAndManner },
    {
      label: "Problem Resolution",
      score: parametersData?.ProblemResolution,
    },
    { label: "Empathy", score: parametersData?.Empathy },
    { label: "Call Closing", score: parametersData?.CallClosing },
  ];

  const overallScore = parametersData?.overallParameterAverage || 0;

  return (
    <Paper
      elevation={0}
      sx={{
        flex: 1,
        p: 2,
        border: "1px solid #e0e0e0",
        borderRadius: 2,
      }}
    >
      <Typography
        variant="h6"
        component="h2"
        fontWeight="600"
        fontSize={"1.125rem"}
      >
        Parameter Scorecard
      </Typography>

      <Box sx={{ mt: 3 }}>
        {parameterData?.map((item, index) => (
          <ScoreItem key={index} label={item?.label} score={item?.score} />
        ))}
      </Box>

      <Box
        sx={{
          mt: 4,
          pt: 2,
          borderTop: "1px solid #e0e0e0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h6"
          component="div"
          color="grey"
          fontSize={"1rem"}
          fontWeight={600}
        >
          Overall Parameter Score
        </Typography>
        <Typography
          variant="h5"
          component="div"
          fontWeight="700"
          fontSize={"1.3rem"}
          color={primary}
        >
          {overallScore?`${overallScore}%`:0}
        </Typography>
      </Box>
    </Paper>
  );
}

export default Parameters;
